module.exports = __webpack_public_path__ + "static/media/386.f414e5af.svg";